import { useEffect } from 'react';
import {
  hurricane_cones_layer,
  hurricane_cones_source_id,
  hurricane_paths_layer,
  hurricane_paths_source_id,
  hurricane_points_layer,
  hurricane_points_source_id,
} from './mapEventsEffects/configureHurricaneLayers';
import dayjs from 'dayjs';
import { MapboxMap } from 'react-map-gl';
import { VectorSourceImpl } from 'mapbox-gl';
import config from '../../../constants/apiConfig';

dayjs.utc();

const useUpdateHurricaneLayer = (
  map: React.MutableRefObject<MapboxMap | undefined>,
  selectedDatetime: dayjs.Dayjs
) => {
  useEffect(() => {
    const formattedDatetime = selectedDatetime
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
    const endDatetime = selectedDatetime.utc().format('YYYY-MM-DD HH:mm:ss');

    const hurricaneSourceIds = [
      hurricane_cones_source_id,
      hurricane_paths_source_id,
      hurricane_points_source_id,
    ] as const;

    const hurricaneTileUrls: Record<string, string> = {
      [hurricane_cones_source_id]: `${config.apiPrefix}/event_tiles/${hurricane_cones_layer}/{z}/{x}/{y}.pbf`,
      [hurricane_paths_source_id]: `${config.apiPrefix}/event_tiles/${hurricane_paths_layer}/{z}/{x}/{y}.pbf`,
      [hurricane_points_source_id]: `${config.apiPrefix}/event_tiles/${hurricane_points_layer}/{z}/{x}/{y}.pbf`,
    };

    hurricaneSourceIds.forEach((sourceId) => {
      if (map.current?.getSource(sourceId)) {
        const source = map.current.getSource(sourceId) as VectorSourceImpl;
        if (source) {
          source.setTiles([
            `${hurricaneTileUrls[sourceId]}?datetime_selected=${formattedDatetime}&end_datetime=${endDatetime}`,
          ]);
        }
      }
    });
  }, [map, selectedDatetime]);
};

export default useUpdateHurricaneLayer;
